export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <a className={`brand ${compact ? "brand--compact" : ""}`} href="/">
      <span className="brand__mark" aria-hidden="true">
        <span />
      </span>
      <span className="brand__copy">
        <strong>FIRST SATURDAY</strong>
        {!compact && <small>FIELD OPERATIONS</small>}
      </span>
    </a>
  );
}
